import { crudActions, crudMutations, crudGetters } from "@/utils/store";

const BASE_URL = `${process.env.BASE_URL_V2}/admin/supporters/`
const BASE_URL_PUBLIC = `${process.env.BASE_URL_V2}/public/footer/supporters/`

export const state = () => ({
  objects: [],
  total: 0,
})

export const mutations = {
  ...crudMutations,
}

export const actions = {
  ...crudActions(BASE_URL),
  async update({}, payload) {
    return this.$axios.$post(`${BASE_URL}`, payload)
  },
}

export const getters = { ...crudGetters }
